<mat-form-field appearance="outline">
    <mat-label>{{ fromLabel }}</mat-label>
    <input matInput [matDatepicker]="fromPicker" [(ngModel)]="dateRange.FromOnOrAfter" />
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="fromPicker"></mat-datepicker-toggle>
    <mat-datepicker #fromPicker></mat-datepicker>
</mat-form-field>
&nbsp;&nbsp;-&nbsp;&nbsp;
<mat-form-field appearance="outline">
    <mat-label>{{ toLabel }}</mat-label>
    <input matInput [matDatepicker]="toPicker" [(ngModel)]="dateRange.ToOnOrBefore" />
    <mat-hint>MM/DD/YYYY</mat-hint>
    <mat-datepicker-toggle matSuffix [for]="toPicker"></mat-datepicker-toggle>
    <mat-datepicker #toPicker></mat-datepicker>
</mat-form-field>
